import { useCallback, useMemo, useState } from 'react'
import {
  clearShortcutDialogOsPreference,
  detectShortcutOs,
  readShortcutDialogOsPreference,
  writeShortcutDialogOsPreference,
  type ShortcutOs,
} from '@/lib/keyboard-platform'

/** Actual device OS — use for header hints, tooltips, and shortcut registration. */
export function useDetectedShortcutOs(): ShortcutOs {
  return useMemo(() => detectShortcutOs(), [])
}

/** Dialog-only OS toggle (preview key labels for another platform). */
export function useShortcutDialogOs() {
  const detected = useDetectedShortcutOs()
  const [override, setOverride] = useState<ShortcutOs | null>(() =>
    readShortcutDialogOsPreference()
  )

  const displayOs: ShortcutOs = override ?? detected

  const setDisplayOs = useCallback((next: ShortcutOs) => {
    setOverride(next)
    writeShortcutDialogOsPreference(next)
  }, [])

  const resetDisplayOs = useCallback(() => {
    setOverride(null)
    clearShortcutDialogOsPreference()
  }, [])

  return {
    displayOs,
    detected,
    setDisplayOs,
    resetDisplayOs,
    isOverridden: override !== null,
  }
}
